import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { ContentPlaceHolderPresetLineBlock } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var BannerPlaceholder = function BannerPlaceholder(props) {
  return ___EmotionJSX(ContentPlaceHolderPresetLineBlock, _extends({
    width: "100%",
    height: "100px"
  }, props));
};